import { useLayoutEffect } from 'react';

/**
 * Блокирует прокрутку страницы через `overflow: hidden` на элементе `<body>`.
 *
 * Использование:
 * - Передайте `true`, чтобы заблокировать скролл.
 * - Передайте `false` или `undefined`, чтобы оставить нормальное поведение.
 *
 * Особенности работы:
 * - При активации сохраняется исходное значение `overflow`.
 * - При размонтировании или смене `locked` обратно — стиль корректно восстанавливается.
 * - Выполняется в `useLayoutEffect`, чтобы исключить видимые скачки контента.
 *
 * @param {boolean} [locked] Флаг, определяющий, нужно ли блокировать прокрутку.
 */
export const useBodyScrollLock = (locked?: boolean) => {
  useLayoutEffect(() => {
    const body = document.body;

    if (!body) {
      return;
    }

    if (locked) {
      const originalStyle = body.style.overflow;
      body.style.overflow = 'hidden';
      body.style.position = 'relative';
      body.style.maxHeight = '100dvh';

      return () => {
        body.style.overflow = originalStyle;
        body.style.position = '';
        body.style.maxHeight = '';
      };
    }
  }, [locked]);
};
